
<template>
  <div class="bgfff out_wrap">
    <div class="back_wrap">
      <el-button @click="$router.go(-1)"><i class="el-icon-arrow-left" />返回</el-button>
      <span class="fs16 bold ml20">商户号互转</span>
    </div>
    <div class="useGuide mb22">
      <div>
        <span class="fs16 bold">使用指南</span>
      </div>
      <div style="line-height: 22px;margin-top: 16px;" class="c9">
        <div>1.商户号转出请填写负数，应少于当前商户号余额。</div>
        <div>2.商户号转入请填写正数。</div>
        <div>3.商户号转入总金额和转出总金额应相等。</div>
      </div>
    </div>
    <div class="pdlr20">
      <div class="mt20 mb20">
        <el-form ref="rechangeModal" :model="form" label-suffix=":" label-width="115px">
          <div class="collection_title bold mb20">商户号可分配金额：￥{{ clientReal || '0.00' }}</div>
          <div class="flex_column">
            <div v-for="(mch_list, index) in form.mch_list" :key="mch_list.mch_id" class="mch-item mr30 mt10">
              <el-form-item :label="`${mch_list.type == 1 ? '微信' : '支付宝'}商户号${index + 1}`">
                {{ mch_list.mch_id }}
              </el-form-item>
              <el-form-item label="可用余额">￥{{ mch_list.use_price || '0.00' }}</el-form-item>
              <el-form-item
                label="分配金额"
                :prop="'mch_list.' + index + '.price'"
                :rules="{
                  required: true, message: '分配金额不能为空', trigger: 'blur'
                }"
              >
                <el-input v-model="mch_list.price" class="w200" @input="(val) => changeValue(val, index)" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="center">
      <el-button type="primary" @click="submitFn('rechangeModal')">确 认 充 值</el-button>
    </div>
  </div>
</template>

<script>

// api接口
import { rechargeInfo, interconvert } from '@/api/refund'
import { uploadFile } from '@/api/common'
import { getBankInfo } from '@/api/refund'
export default {
  data() {
    return {
      dialogVisible: false,
      fileList: [],
      bankInfo: {},
      form: {
        mch_list: [] // 分配商户号金额
      },
      rechangeDetail: {} // 充值详情
    }
  },
  computed: {},
  watch: {
    rechangeDetail: {
      handler(val) {
        if (val && val.mch_list && val.mch_list.length) {
          val.mch_list.forEach(item => {
            this.form.mch_list.push({
              mch_id: item.mch_id,
              use_price: (item.use_price / 100).toFixed(2),
              type: item.type,
              price: 0
            })
          })
        }
      },
      deep: true
    }
  },
  created() {
    this.rechargeFn()
  },
  mounted() {
    getBankInfo().then(res => {
      this.bankInfo = res.data
    })
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    // 充值
    async rechargeFn() {
      // 获取充值详情
      const res = await rechargeInfo()
      if (res.code === 200) {
        this.rechangeDetail = res.data
      }
    },
    async submitFn(formName) {
      const valid = await this.$refs[formName].validate()
      if (!valid) return
      var sum = 0
      this.form.mch_list.forEach(item => {
        sum = this.add(sum, item.price)
      })
      if (0 !== sum) {
        this.$message({ type: 'error', message: '商户号互转金额不一致!' })
        return
      }
      if (valid) {
        const res = await interconvert(this.form)
        if (res.code === 200) {
          this.$message({ type: 'success', message: '充值申请提交成功!' })
          this.$router.go(-1)
          this.fileList = []
          this.form.mch_list = [] // 分配商户号金额
        // this.query()
        }
      }
    },
    formatToTwoDecimal(event) {
      // 使用正则表达式限制只能输入两位小数
      this.inputValue = event.target.value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3');
    },
    changeValue(val, i) {
      this.form.mch_list[i].price = val.replace(/[^\-\d\.]/g, '').replace(/^\-\./g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    },
    beforeUploadFile(file) {
      const type = /^(.doc|.docx|.pdf|.jpg|.png|.xls|.xlsx)$/.test(file.name.slice(file.name.lastIndexOf('.')))
      const size = file.size / 1024 / 1024 < 20
      if (!type) {
        this.$message('不支持该文件类型,请重新选择')
      }
      if (!size) {
        this.$message('文件大小不可超过20MB')
      }
      return type && size
    },
    doUploadFile(file) {
      console.log(file, 'file')
      const params = new FormData()
      params.append('file', file.file)
      uploadFile(params).then(res => {
        if (res.code === 200) {
          this.form.pic = res.data
        }
      })
    },
    handleExceed() {
      this.$message('最多可上传1个文件')
    },
    handleRemove() {
      this.form.pic = ''
    },
    validatorFn(rule, value, callback) {
      if (+value <= 0) {
        callback(new Error(`金额必须大于0`))
      } else {
        callback()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.back{
    width: 69px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    border: 1px solid #1890FF;
    color: #1890FF;
    font-size: 14px;
}
.flex_start{
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.collection_title{
 width: 100%;
 height: 42px;
 line-height: 42px;
 background: #FAFAFA;
 padding-left: 22px;
 border-left: 4px solid #1890FF;
 font-size: 15px;
}
.plr100{
    padding: 0px 100px;
}
.line{
    width: 1px;
    height: 100%;
    background: #D8D8D8;
}
.mch-item{
  padding:  10px;
  margin-bottom: 10px;
  border: 1px solid #EDEDED;
  width: 340px;
//   &:last-child{
//     margin-bottom: 0;
//   }
}
.flex_column{
     flex-flow: row wrap;
    justify-content: flex-start;
    display: flex;
    padding: 0px 30px;
}
.pdlr20{
    padding: 0px 20px;
}
.mr30{
  margin-right: 30px;
}
.posifix{
   position: fixed;
    left: 0;
    bottom: 50px;
  // padding-left: 200px;
  // padding-right: 20px;
  width: 100%;
  transform: translateZ(0)
}
.el-form-item { margin-bottom: 10px;}
</style>
